import axios from 'axios'



export function request(config){
    const instance = axios.create({
        baseURL:'https://gykzb.xaeduyun.cn',
        withCredentials: true
    })
    
    //ajax本身就是Promise的形式
    return instance(config)
}
